module.exports = __webpack_public_path__ + "img/Plus.79d3d574.svg";